module.exports = __webpack_public_path__ + "static/media/content_and_sms.457981fe.png";